import { render, staticRenderFns } from "./supplierGoods.vue?vue&type=template&id=581237a8&scoped=true&"
import script from "./supplierGoods.vue?vue&type=script&lang=js&"
export * from "./supplierGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581237a8",
  null
  
)

export default component.exports